import { Type } from 'class-transformer';
import { AuditMetadata } from '@core/model/auditMetadata.model';

export class ExchangeRate {
  id!: number
  fromCurrencyCode!: string
  toCurrencyCode!: string
  exchangeRate!: number
  @Type(() => ExchangeRateVersion) versionHistory: ExchangeRateVersion[]
  @Type(() => AuditMetadata) auditMetadata!: AuditMetadata

  constructor(currencyCode: string) {
    this.toCurrencyCode = currencyCode
  }
}

export class ExchangeRateVersion {
  exchangeRate!: number
  createdBy!: string
  @Type(() => Date) createdOn!: Date
}
